<script setup lang="ts">
import { FontOptions } from "./FontOptions";
import {defineModel, nextTick, ref, watch} from "vue";
import {useStore} from "vuex";

const store = useStore();

const model = defineModel({ required: true });
const select = ref(null);
const kpsSettings = window.measurementSelectorVariables;
const internalModel = ref(model);

watch( internalModel, ( newValue: string ) => {
	updateModel( newValue );
} );

const updateModel = async (newValue: string|number) => {
	await loadFont(newValue);
	model.value = newValue;
};

async function setPosition(): Promise<void> {
	await nextTick();
	const active = select.value.$el.querySelector(
		".vs__dropdown-menu .vs__dropdown-option--selected"
	);

	if (active) {
		setTimeout(() => {
			active.scrollIntoView({ behavior: "smooth", block: "end" });
		}, 200);
	}
}

async function loadFont(font): Promise<void> {
	const fontObject = store.getters.getSelectedFontObject;

	if ( fontObject !== undefined ) {
		return fontObject;
	}

	await store.dispatch( "loadFont", font, { root: true } );
}

</script>
<template>
	<v-select
		v-model="internalModel"
		:options="FontOptions"
		class="measurements-selector__font-select"
		inputId="measurements-selector-font-select"
		:placeholder="$i18n.text.selectFont"
		ref="select"
		@open="setPosition"
	>
		<template #search="{ attributes, events }">
			<input
				class="vs__search"
				:required="!model"
				v-bind="attributes"
				v-on="events"
			/>
		</template>
		<template v-slot:option="option">
			<img
				:src="kpsSettings.fontDirUrl + option.label + '-v1.png'"
				:alt="option.label"
				loading="lazy"
			/>
		</template>
	</v-select>
</template>

<style scoped lang="scss">
img {
	width: auto;
	max-width: 100%;
	min-height: 15px;
	max-height: 20px;
}
</style>
